module.exports = __webpack_public_path__ + "static/media/java2.75e92d04.png";